export enum EWorkforceRole {
    EMPLOYEE = "employee",
    CONTRACTOR = "contractor",
    SUPERVISOR = "supervisor",
    VIRTUAL_RECEPTIONIST = "virtual_receptionist",
    ACCOUNT_MANAGER = "account_manager",
}